<template>
    <div class="uzhnet-input-line">
        <input
            class="uzhnet-input-line__input"
            :placeholder="placeholder"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :type="contentType"
            :disabled="disabled"
        >
        <div class="uzhnet-input-line__label">
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'UzhnetInputLine',

    props: {
        placeholder: {
            type: String,
            default: 'Ваш текст...'
        },
        modelValue: {
            type: String,
            default: ''
        },
        contentType: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: 'Ваш текст...'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
    .uzhnet-input-line {
        position: relative;
        height: max-content;
        width: 100%;

        display: flex;
        justify-content: space-between;
        align-items: end;

        padding-bottom: 13px;
        border-bottom: 1px solid rgba(232, 232, 232, 0.2);
        
        &__input {
            border: none;
            background: transparent;
            padding: 0 15px;
            z-index: 1;
            font-size: 13px;
            color: #E0C522;
            box-sizing: border-box;
            outline: none;
            width: 100%;

            //disabled
            &:disabled {
                color: #CACACA;
            }
        }

        &__label {
            color: #CACACA;
            font-size: 10px;
            font-family: 'Montserrat', sans-serif;
        }

    }
</style>